module.exports = __webpack_public_path__ + "img/23_left.6192c663.png";